import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/Layout';
import { LookupResultContextProvider } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { PoaSign } from '@/components/tax-refund/power-of-attorney/PoaSign.tsx';
import { BusinessType } from '@/lib/types/request.ts';

const PowerOfAttorneySignPage = ({ businessType }: { businessType: BusinessType }) => {
  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'request_before_autograph'}>
        <LookupResultContextProvider businessType={businessType}>
          <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'request_back' } }} mainClassName={'flex flex-col'}>
            <PoaSign businessType={businessType} />
          </Layout>
        </LookupResultContextProvider>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default PowerOfAttorneySignPage;

export const getServerSideProps = (async ({ query }) => {
  if (query?.type) {
    return { props: { businessType: query?.type as BusinessType } };
  }
  return { props: { businessType: '' } };
}) satisfies GetServerSideProps;
